import React from 'react';
import Icon from '../Icon/Icon';
import { hydrateRoute, stringifyFilter } from '../../utils';
import Link from '../Link/Link';
import { useGlobalValue } from '../../state/GlobalProvider';
import styles from './AuditSection.module.sass';

const AuditSection = ({
  data,
  links,
  modifiers,
  activity
} = {}) => {
  const {
    i18n,
    params
  } = useGlobalValue();
  const modifiersClasses = (modifiers || []).map(m => styles[m]).filter(m => m).join(' ');
  const total = data && data.length ? data.reduce((acc, {
    count
  }) => {
    acc += parseInt(count, 10);
    return acc;
  }, 0) : 0;
  return total ? /*#__PURE__*/React.createElement("div", {
    className: `${styles['root']} ${modifiersClasses}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['details']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h4", null, i18n`Audit result`, " | ", /*#__PURE__*/React.createElement(Link, {
    className: styles['see-all'],
    to: hydrateRoute(links[0].to, params),
    label: links[0].name
  }))), /*#__PURE__*/React.createElement("div", null, links[1] && /*#__PURE__*/React.createElement(Link, {
    className: styles['see-all'],
    to: hydrateRoute(links[1].to, params),
    label: links[1].name || i18n('See All')
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['summary-container']
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("small", null, /*#__PURE__*/React.createElement("strong", null, total), " ", i18n`findings were found during the audit!`)), /*#__PURE__*/React.createElement("div", {
    className: styles['risk-container']
  }, (data || []).sort((first, second) => second.severity.localeCompare(first.severity)).map(({
    severity,
    count
  }, index) => {
    const name = i18n(`${severity}`);
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Icon, {
      name: severity,
      className: `${styles[`icon-${severity}`]} ${styles['icon']}`
    }), /*#__PURE__*/React.createElement("small", {
      className: `${styles['risk']} ${styles[severity] || ''}`
    }, /*#__PURE__*/React.createElement(Link, {
      to: hydrateRoute(`?filter=${stringifyFilter([{
        column: 'severity',
        filters: [{
          value: severity
        }]
      }])}&resetFilters=${Date.now()}`, {
        params
      }),
      label: i18n`${count} ${name}`
    })));
  }))))) : /*#__PURE__*/React.createElement("div", {
    className: `${styles['root']} ${modifiersClasses}`
  }, data !== undefined && !activity && /*#__PURE__*/React.createElement("div", {
    className: `${styles['content']} ${styles['no-content']}`
  }, /*#__PURE__*/React.createElement("h4", null, "Audit result"), /*#__PURE__*/React.createElement("small", null, "No results found during the auditing!")));
};

export default AuditSection;